// All needed imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { TravelStudentsIncomingComponent } from './travel-students-incoming-component/travel-students-incoming.component';

@NgModule({
  // Declarate the needed components
  declarations: [
    TravelStudentsIncomingComponent
  ],
  // Import modules which will be used in this module
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule
  ],
  // Indicate the modules which will be used in other modules
  exports: [
    TravelStudentsIncomingComponent
  ]
})
export class Form6Module { }
